module.exports = __webpack_public_path__ + "static/media/cq_scarica_pdf_rosso.52fc44dd.svg";